import { HIGHLIGHT_WORKOUT_QUERY_PARAM } from 'src/constants/programme-overview-url'

export const getHighlightWorkoutIdFromSearch = (search: string): string | undefined => {
  const v = new URLSearchParams(search).get(HIGHLIGHT_WORKOUT_QUERY_PARAM)
  return v?.trim() || undefined
}

export type BuildProgrammeOverviewUrlOptions = {
  isProgressReady: boolean
  nextIncompleteWeek: number | undefined
  nextIncompleteWorkoutId: string | undefined
}

/**
 * Programme overview path with optional week + next-workout highlight for deep links from Keep going / active cards.
 */
export const buildProgrammeOverviewUrl = (programmeId: string, options: BuildProgrammeOverviewUrlOptions): string => {
  const { isProgressReady, nextIncompleteWeek, nextIncompleteWorkoutId } = options
  const base = `/programmes/${programmeId}`
  if (!isProgressReady || !nextIncompleteWorkoutId) {
    return base
  }
  const params = new URLSearchParams()
  if (nextIncompleteWeek != null && nextIncompleteWeek > 0) {
    params.set('week', String(nextIncompleteWeek))
  }
  params.set(HIGHLIGHT_WORKOUT_QUERY_PARAM, nextIncompleteWorkoutId)
  const qs = params.toString()
  return qs ? `${base}?${qs}` : base
}
